import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=4bc411ca&scoped=true&"
import script from "./FooterBottom.vue?vue&type=script&lang=ts&"
export * from "./FooterBottom.vue?vue&type=script&lang=ts&"
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=4bc411ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc411ca",
  null
  
)

export default component.exports